import '@unicorn/unicorn.js';
import '@unicorn/ui/ui-bootstrap5.js';
import '@vendor/sweetalert/dist/sweetalert.min.js';

u.use(UIBootstrap5.UIBootstrap5);

export default u;

const cartCount = u.data('cartCount');

await u.domready();

// home, course-list filter bar
const filterBar = document.querySelector('.j-filter');
const cartQuantity = document.querySelector('[data-role=cart-count]') as HTMLButtonElement;

if (filterBar) {

  new TomSelect('#filter-courses-category', {
    create: false,
    maxItems: 1,
    controlInput: null,
    allowEmptyOption: true,
    sortField: {
      field: "value",
      direction: "asc"
    }
  });

  new TomSelect('#filter-tag', {
    sortField: {
      field: "value",
      direction: "asc"
    },
    plugins: {
      'checkbox_options': {
        'checkedClassNames': ['ts-checked', 'form-check-input'],
        'uncheckedClassNames': ['ts-unchecked', 'form-check-input'],
      }
    },
  });
}

if (cartQuantity) {
  if (cartCount <= 0) {
    cartQuantity.classList.add('d-none');
  } else {
    cartQuantity.classList.remove('d-none');
  }
}

u.delegate('body', '[data-task=add-to-cart]', 'click', (e: Event) => {
  addToCart(e.currentTarget as HTMLButtonElement);
});

u.on('load.share.this', () => {
  const sharethisScript = document.createElement('script');

  sharethisScript.src = 'https://platform-api.sharethis.com/js/sharethis.js#property=67adcf571f190b001a2ea6e8&product=sop';
  sharethisScript.async = true;

  document.head.appendChild(sharethisScript);
});

async function addToCart(el: HTMLButtonElement|HTMLAnchorElement) {
  try {
    await sendAddAction(el);
  } catch (e: any) {
    u.alert(e.message, '', 'warning');
    return;
  }

  const v = await swal({
    title: '已加入購物車',
    buttons: [
      '繼續購物',
      '前往結帳'
    ]
  });

  if (!v) {
    return;
  }

  toCartPage();
}

async function sendAddAction(el: HTMLButtonElement|HTMLAnchorElement) {
  const lessonId = el.dataset.id;

  if (!lessonId) {
    throw new Error('No lesson ID');
  }

  try {
    const res = await u.$http.post(
      '@cart_ajax/addToCart',
      {
        id: lessonId,
      }
    );

    updateCartButton(res.data.data);

    return res.data;
  } catch (e) {
    console.error(e);
    throw e;
  }
}

function toCartPage() {
  location.href = u.route('cart');
}

function updateCartButton(data: any[]) {
  const count = data.length;

  if (cartQuantity) {
    if (count <= 0) {
      cartQuantity.classList.add('d-none');
    } else {
      cartQuantity.textContent = count.toFixed();
      cartQuantity.classList.remove('d-none');
    }
  }
}
